import React from 'react';

const AchievementStatusCard = ({status}) => {
	return (
			<div className='flex flex-col items-center gap-2 mb-8'>
				<img
					className='max-w-40 max-h-40 object-contain'
					src={status.icon}
					alt={status.title}
				/>
				<h2 className='text-4xl font-bold text-primary'>
					{status.title}
				</h2>
				{status.description && (
					<p className='text-sm'>
						{status.description}
					</p>
				)}
			</div>
	);
};

export default AchievementStatusCard;